<div [ngClass]="circleClass">
  <div class="colour-box right-side">
    <div class="box" [style.transform]="rightSideTransform" [style.backgroundColor]="colour"></div>
  </div>
  <div class="colour-box left-side">
    <div class="box" [style.transform]="leftSideTransform" [style.backgroundColor]="colour"></div>
  </div>
  <div class="overlay">
    <div class="value" [style.transform]="valueTransform">
      {{ percentValueText }}
    </div>
  </div>
</div>
<div class="size"></div>
<svg
  *ngIf="!maxFill"
  class="arrow"
  width="54"
  height="54"
  viewBox="0 0 54 54"
  [style.fill]="colour"
  [style.stroke]="colour"
  xmlns="http://www.w3.org/2000/svg"
>
  <path d="M39.1536 14.4052L1.604 52.0808" stroke-width="2.44183" stroke-linecap="round" stroke-linejoin="round" />
  <path
    d="M26.4209 27.2461V14.6354C26.4209 14.5284 26.4631 14.4257 26.5382 14.3495L40.0051 0.705762C40.2607 0.446806 40.7017 0.627798 40.7017 0.991652V12.8974"
  />
  <path
    d="M26.5254 27.3652H38.9952C39.104 27.3652 39.2083 27.3217 39.2847 27.2443L52.7761 13.5898C53.0301 13.3328 52.848 12.8968 52.4866 12.8968H40.7027"
  />
</svg>
